import React from "react";
import AvisoSoloLectura from "./AvisoSoloLectura";
import { rolDeSesion, esAdministrador, veCobroConPinpad, MENSAJE_SOLO_LECTURA } from "../utilities/permisos";

const VistaCobroExAlumnos = ({
  catalogo,
  referencia,
  cargandoReferencia,
  carrito,
  agregarAlCarrito,
  quitarDelCarrito,
  totalCarrito,
  nombreSolicitante,
  setNombreSolicitante,
  procesarCobroPinpad,
  procesarCobroVentanilla,
  loading,
  mensaje,
  modalExito,
  setModalExito,
  onVerHistorial,
  onVerValidar
}) => {
  const rolCajero = rolDeSesion();
  const sinReferencia = !cargandoReferencia && !referencia;

  return (
    <div className="cobro-layout">
      {/* Columna izquierda: catalogo */}
      <div className="catalogo-section">
        <div className="catalogo-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <h3>🎓 Cobro a Ex-alumnos</h3>
            <p>Documentos disponibles para quienes no tienen registro en el Sistema de Control Escolar.</p>
          </div>
          {referencia && (
            <div className="fila-botones">
              <button
                className="btn-select historial"
                onClick={onVerHistorial}
                style={{ padding: "8px 15px", borderRadius: "4px", cursor: "pointer", fontWeight: "bold", fontSize: "13px" }}
              >
                📜 Historial
              </button>
              <button
                className="btn-select validar"
                onClick={onVerValidar}
                style={{ padding: "8px 15px", borderRadius: "4px", cursor: "pointer", fontWeight: "bold", fontSize: "13px" }}
              >
                🏦 Validar Pago
              </button>
            </div>
          )}
        </div>

        {cargandoReferencia ? (
          <div style={{ color: "#666", padding: "10px" }}>⏳ Cargando...</div>
        ) : sinReferencia ? (
          <div className="alert-box alert-error">
            <span className="alert-icon">⚠️</span>
            No hay una referencia de ex-alumnos configurada para este plantel. Contacta a Sistemas.
          </div>
        ) : (
          <div className="conceptos-grid-2col">
            {catalogo.length === 0 ? (
              <p style={{ color: "#888", padding: "10px" }}>
                Todavia no hay documentos habilitados para ex-alumnos en el catalogo.
              </p>
            ) : (
              [...catalogo]
                .sort((a, b) => a.concepto.localeCompare(b.concepto))
                .map((concepto) => (
                  <div key={concepto.id} className="concepto-fila">
                    <div className="concepto-detalle">
                      <span className="concepto-nombre">{concepto.concepto}</span>
                    </div>
                    <div className="concepto-accion">
                      <span className="concepto-costo">${Number(concepto.precio).toFixed(2)}</span>
                      <button className="btn-add-small" onClick={() => agregarAlCarrito(concepto)}>
                        +
                      </button>
                    </div>
                  </div>
                ))
            )}
          </div>
        )}

        {mensaje.texto && (
          <div className={`alert-box ${mensaje.tipo === "success" ? "alert-success" : "alert-error"}`}>
            <span className="alert-icon">{mensaje.tipo === "success" ? "✅" : "⚠️"}</span>
            {mensaje.texto}
          </div>
        )}
      </div>

      {/* Columna derecha: ticket */}
      <div className="ticket-section">
        <div className="ticket-card">
          <h3 className="ticket-title">Ticket de Cobro</h3>

          <div style={{ marginBottom: "15px" }}>
            <label className="filter-label">Nombre de quien solicita</label>
            <input
              type="text"
              className="search-input"
              placeholder="Nombre completo"
              value={nombreSolicitante}
              onChange={(e) => setNombreSolicitante(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="ticket-items-container">
            {carrito.length === 0 ? (
              <p className="ticket-vacio">El carrito esta vacio.</p>
            ) : (
              carrito.map((item) => (
                <div key={item.id} className="ticket-item">
                  <span className="item-nombre">{item.concepto}</span>
                  <div className="item-controles">
                    <span className="item-cantidad" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <button
                        onClick={() => quitarDelCarrito(item.id)}
                        className="btn-cantidad"
                      >
                        -
                      </button>
                      Cant: {item.cantidad}
                      <button
                        onClick={() => agregarAlCarrito(item)}
                        className="btn-cantidad"
                      >
                        +
                      </button>
                    </span>
                    <span className="item-subtotal">${Number(item.precio * item.cantidad).toFixed(2)}</span>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="ticket-footer">
            <div className="ticket-total">
              <span>Total:</span>
              <span className="total-monto">${Number(totalCarrito).toFixed(2)}</span>
            </div>
            <div className="btn-action-container">
              <AvisoSoloLectura visible={esAdministrador(rolCajero)} />
              {veCobroConPinpad(rolCajero) && (
                <button
                  className="btn-pagar-grande"
                  disabled={esAdministrador(rolCajero) || carrito.length === 0 || loading || !referencia}
                  title={esAdministrador(rolCajero) ? MENSAJE_SOLO_LECTURA : undefined}
                  onClick={procesarCobroPinpad}
                >
                  {loading ? "Procesando..." : "💳 Cobrar con Pinpad"}
                </button>
              )}
              <button
                className="btn-pagar-grande btn-pagar-verde"
                disabled={carrito.length === 0 || loading || !referencia}
                onClick={procesarCobroVentanilla}
              >
                {loading ? "Procesando..." : "🏦 Generar Referencia"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {modalExito?.visible && (
        <div className="modal-overlay-exito">
          <div className="modal-card-exito">
            <div className="modal-icon-exito">🎉</div>
            <h2 className="modal-title-exito">¡Cobro Registrado con Éxito!</h2>
            <div className="modal-detalles-exito">
              <div className="detalle-row-exito">
                <span>Solicitante:</span>
                <strong>{modalExito.nombre}</strong>
              </div>
              <div className="detalle-row-exito">
                <span>Monto:</span>
                <strong className="monto-resaltado-exito">
                  ${modalExito.monto.toLocaleString("en-US", { minimumFractionDigits: 2 })} MXN
                </strong>
              </div>
              <div className="detalle-row-exito">
                <span>No. Autorización:</span>
                <strong className="codigo-exito">{modalExito.autorizacion}</strong>
              </div>
              <div className="detalle-row-exito">
                <span>Referencia:</span>
                <strong className="codigo-exito">{modalExito.referencia}</strong>
              </div>
            </div>
            <button className="btn-modal-aceptar-exito" onClick={() => setModalExito({ ...modalExito, visible: false })}>
              Aceptar y Continuar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VistaCobroExAlumnos;
